import { Transition } from "react-transition-group";
import {
  CompareButton,
  MapButton,
  MeasureButton,
  ViewButton,
} from "./components";
import { useRef } from "react";
import { TransitionProps } from "react-transition-group/Transition";

/**
 * `$transitionShortMedium` in,
 * `$transitionShort` out
 */
const TIMEOUTS: TransitionProps["timeout"] = {
  enter: 0,
  appear: 450,
  exit: 300,
};

interface KeyButtonsProps {
  menusInView: boolean;
}

const KeyButtons: React.FC<KeyButtonsProps> = ({ menusInView }) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <Transition
      nodeRef={nodeRef}
      in={menusInView}
      timeout={TIMEOUTS}
      mountOnEnter
      // Don't unmount as this is a key component of the UI
      // unmountOnExit
    >
      {(transitionState) => (
        <div
          ref={nodeRef}
          className={`KeyButtons DisplayFlex LargeGap ${transitionState}`}
        >
          {/* View */}
          <ViewButton />
          {/* Measure */}
          <MeasureButton />
          {/* Compare */}
          <CompareButton />
          {/* Map */}
          <MapButton />
        </div>
      )}
    </Transition>
  );
};

export default KeyButtons;
